import React, { useState, useEffect } from "react";
import { AddUserToGroup, GroupInfo } from "../../../redux/actions/chatActions";
import { useDispatch, useSelector } from "react-redux";
import { BsX } from "react-icons/bs";
import xCircle from "../../../assets/icons/x-circle.svg";

const AddMemberToGroup = ({
  fetchTransChatList,
  addGroupMemberSearch,
  setGroupInfoDetail,
  selectedRoom,
  setAddGroupMemberSearch,
  groupDetails,
  setAddMemberGroupList,
}) => {
  const dispatch = useDispatch();
  const AddUserToGroupReq = useSelector((state) => state.chat.AddUserToGroup);
  const currentUserId = window.localStorage.getItem("userid");
  const [newAddGroupMember, setNewAddGroupMember] = useState([]);
  const t = (key) => fetchTransChatList?.[key] || "";
  const handleOnGroupAddMember = (e, room) => {
    setNewAddGroupMember((prevList) => [...prevList, room]);
  };
  const FetchUsersToGroupData = useSelector(
    (state) => state.chat.FetchUsersToGroup
  );

  useEffect(() => {
    setAddGroupMemberSearch("");
  }, [AddUserToGroupReq]);

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: "8px 8px 0 0",
        height: "100%",
      }}
    >
      {newAddGroupMember?.length > 0 && (
        <div className="group-item-height">
          {newAddGroupMember?.map((tag, index) => {
            return (
              <>
                <span key={index} className="membergroup-style">
                  {`${tag?.firstname + " " + tag?.lastname}`}
                  <span className="cross-icon-style-cross"></span>
                  <BsX
                    className="times-icon-style-time"
                    onClick={() => {
                      let temp = [...newAddGroupMember];
                      temp = temp.filter((item) => item != tag);
                      setNewAddGroupMember(temp);
                    }}
                    style={{ height: "20px", width: "20px" }}
                  />
                </span>
              </>
            );
          })}
        </div>
      )}
      <div
        className="d-flex  justify-content-between"
        style={{
          borderBottom: "2px solid #47575726",
          height: "66px",
          borderRadius: "8px 8px 0 0",
        }}
      >
        <input
          type="text"
          style={{
            outline: "none",
            margin: "0 0 0 0px",
            fontSize: "0.878vw",
            fontWeight: addGroupMemberSearch ? "400" : "400",
            color: addGroupMemberSearch ? "#333333" : "#333333",
            fontSize: "12px",
          }}
          placeholder={t("Choose members")} //"Choose members"
          className="search-style ms-2"
          value={addGroupMemberSearch}
          onChange={(e) =>
            setAddGroupMemberSearch(e.target.value.toLowerCase())
          }
        />
        <img
          src={xCircle}
          width={26}
          height={26}
          alt="#"
          onClick={() => {
            setNewAddGroupMember([]);
            setGroupInfoDetail(true);
            setAddMemberGroupList(false);
          }}
          className="mt-3 me-3 cursor-pointer"
        ></img>
      </div>
      <div
        className="add-groupMember-scroll"
        style={{
          height: `calc(100% - ${
            newAddGroupMember?.length > 0 ? "143px" : "150px"
          })`,
          overflowY: "auto",
          position: "relative",
        }}
      >
        {FetchUsersToGroupData?.status === true
          ? FetchUsersToGroupData?.data
              ?.filter(
                (sourceItem) =>
                  !groupDetails[0]?.groupuser.some(
                    (removeItem) => sourceItem?.userid === removeItem?.userid
                  )
              )
              .filter(
                (sourceItem) =>
                  !newAddGroupMember.some(
                    (removeItem) => sourceItem?.userid === removeItem?.userid
                  )
              )
              .filter((data) => {
                const fullName = `${data?.firstname} ${data?.lastname}`;
                return (
                  data?.firstname
                    ?.toLowerCase()
                    .includes(addGroupMemberSearch?.toLowerCase()) ||
                  data?.lastname
                    ?.toLowerCase()
                    .includes(addGroupMemberSearch?.toLowerCase()) ||
                  fullName
                    ?.toLowerCase()
                    .includes(addGroupMemberSearch?.toLowerCase())
                );
              })
              .filter((item) => {
                return item.isactive == 1;
              })
              .map((room, index) => (
                <div
                  className={
                    selectedRoom && room.groupid === selectedRoom.groupid
                      ? `single-person  c02A29B`
                      : `singl  e-person`
                  }
                  style={{ paddingInline: "20px" }}
                  key={`room-${index}`}
                  onClick={(e) => {
                    handleOnGroupAddMember(e, room);
                  }}
                >
                  <div className="single-person-grid2">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        position: "relative",
                      }}
                    >
                      <div
                        className="name-image-style temp-image-style"
                        style={{
                          height: "44px",
                          width: "44px",
                        }}
                      >
                        {room?.imageurl ? (
                          <img
                            src={room?.imageurl}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              zIndex: "0",
                              borderRadius: "100%",
                            }}
                          />
                        ) : (
                          <>
                            <div
                              style={{
                                borderRadius: "50%",
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                color: "#FFFFFF",
                                fontSize: "14px",
                                lineHeight: "22px",
                                fontWeight: "700",
                                background:
                                  "#95A7C6 0% 0% no-repeat padding-box",
                              }}
                            >
                              {room?.lastname?.toUpperCase()
                                ? room?.firstname.slice(0, 1).toUpperCase() +
                                  room?.lastname.slice(0, 1).toUpperCase()
                                : room?.firstname?.slice(0, 1).toUpperCase() +
                                  room.firstname?.slice(1, 2).toUpperCase()}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          textAlign: "start",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          className="name-style"
                          style={{
                            fontSize: "14px",
                            color: `#333333`,
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          {/* {`${room?.firstname + " " + room?.lastname}`} */}
                          {`${room?.firstname}`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          : ""}
      </div>
      <div
        className="group-member-div"
        style={{ position: "sticky", width: "100%", bottom: 0 }}
      >
        <button
          className="invitebtn-add"
          disabled={newAddGroupMember?.length === 0}
          onClick={() => {
            let reqArray = [];
            newAddGroupMember?.forEach((elements) => {
              reqArray.push({
                userid: elements?.userid,
              });
            });
            if (reqArray) {
              dispatch(
                AddUserToGroup(
                  groupDetails[0]?.groupid,
                  currentUserId,
                  reqArray
                )
              );
              setGroupInfoDetail(true);
              dispatch(GroupInfo(currentUserId, selectedRoom?.groupid));
              setNewAddGroupMember([]);
              setAddMemberGroupList(false);
            }
          }}
        >
          {" "}
          {t("Add")}
        </button>
      </div>
    </div>
  );
};

export default AddMemberToGroup;
